module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vvc-tab",
    class: {
      transition: _vm.moving, 'vvc-tab-active': _vm.tab.state.active
    },
    style: ({
      width: _vm.style.width,
      'background-color': _vm.bgc,
      'z-index': _vm.zIndex
    }),
    attrs: {
      "draggable": _vm.tab._tab_.id !== 'Tab_0'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.activate($event)
      },
      "dragstart": _vm.dragStart,
      "drag": _vm.dragging,
      "dragend": _vm.dragEnd
    }
  }, [_vm._v("\n  " + _vm._s(_vm.tab._tab_.label) + "\n  "), (_vm.tab._tab_.id !== 'Tab_0') ? _c('span', {
    staticClass: "vvc-tab-close",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.close($event)
      }
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-260e6576!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/tabbar/src/tab.vue
// module id = 627
// module chunks = 0